

import styles from './SpotsPage.module.css';
import stylesPanel from '../../../../styles/Panel.module.css';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderTituloComponent from '../../../../components/header-titulo/HeaderTituloComponent.js';
import InputText from '../../../../components/InputText/InputText.js';
import BotonPrincipal from '../../../../components/boton-principal/BotonPrincipal.js';
import { useDispatch, useSelector } from 'react-redux';
import { cerrarSesion } from '../../../../redux/userActions.js';
import imagenSpotNoFoto from '../../../../assets/images/spot-no-image.jpg';
import { srvObtenerFotoPerfil } from '../../../../services/usuarios/srvObtenerFotoPerfil.js';
import { srvBuscarTodosLosSpots } from '../../../../services/spots/srvBuscarTodosLosSpots.js';
import ProgressBar from '../../../../components/progress-bar/ProgressBar.js';
import { srvBuscarCantidadTotemsSinActivar } from '../../../../services/totems/srvBuscarCantidadTotemsSinActivar.js';
import CuadroAyuda from '../../../../components/cuadro-ayuda/CuadroAyuda.js';
import SimuladorPage from '../encuestas/simulador/SimuladorModal.js';
import ConfirmationModalComponent from '../../../../components/confirmation-modal/ConfirmationModalComponent.js';
import { srvDesactivarEncuesta } from '../../../../services/encuestas/srvDesactivarEncuesta.js';


function SpotsPage(props) {
    const dispatch = useDispatch();
    // dispatch(cerrarSesion());
    const navigate = useNavigate();
    const [error, setError] = useState(false);
    const [errorBuscar, setErrorBuscar] = useState('');
    const [textoBuscado, setTextoBuscado] = useState('');
    const [spotsSinFiltrar, setSpotsSinFiltrar] = useState([]);
    const [spotsFiltrados, setSpotsFiltrados] = useState([]);
    const [isModalSimuladorOpen, setIsModalSimuladorOpen] = useState(false);
    const [cantidadTotemsSinActivar, setCantidadTotemsSinActivar] = useState([])

    const [spotSelected, setSpotSelected] = useState(null);


    const [isOpenModal, setIsOpenModal] = useState(false);

    const ACCION_VACIA = { accion: "", titulo: "", mensaje: "" }
    const ACCION_DESACTIVAR = { accion: "ACCION_DESACTIVAR", titulo: "Desactivar encuesta", mensaje: "¿seguro que deseas desactivar la encuesta?. Esto se aplicará a todos los totems" }

    const [accionAConfirmar, setAccionAConfirmar] = useState(ACCION_VACIA);

    const userData = useSelector(state => state.authInfo);

    useEffect(() => {
        getSpotsFromServer()
        buscarCantidadTotemsSinActivar()
    }, [])


    useEffect(() => {
        console.log("Nuevo texto a buscar ", textoBuscado)
        console.log("usuariosSinFiltrar ", spotsSinFiltrar)
        setSpotsFiltrados(spotsSinFiltrar.filter(usuario => {
            const textoBuscadoEnMinusculas = textoBuscado.toLowerCase();
            return usuario.spot.toLowerCase().includes(textoBuscadoEnMinusculas) || usuario.descripcion.toLowerCase().includes(textoBuscadoEnMinusculas) || usuario.creadoPor.toLowerCase().includes(textoBuscadoEnMinusculas)
        }
        ))

    }, [textoBuscado, spotsSinFiltrar]);



    const getSpotsFromServer = () => {
        // console.log("asds")
        const fetchData = async () => {
            try {
                const spotsFromServer = await srvBuscarTodosLosSpots(userData);
                console.log(spotsFromServer)
                // console.log("authorization", userInfo.headers.getAuthorization)
                if (spotsFromServer) {
                    console.log(spotsFromServer.data)

                    setSpotsSinFiltrar(spotsFromServer.data);
                    // Cargar las imágenes después de actualizar el estado de los usuarios
                    cargarImagenes(spotsFromServer.data);
                    // props.handleLogged(userInfo.data)
                }
                // navigate("/panel");
                else
                    setError("Error al buscar los usuarios")
            } catch (error) {
                console.log("error.message", "+" + error + "+")
                if (error == 'Error: Error del servidor: 401') {
                    console.log("ahora si 401")
                    dispatch(cerrarSesion());
                } else {
                    setError('Error al procesar la solicitud');
                }


            }
        };
        fetchData();
    }



    const defaultImage = '../../../../assets/icons/perfil.jpg'; // Ruta a la imagen por defecto en tu carpeta assets

    const cargarImagenes = async (usuarios) => {
        const usuariosConImagenes = await Promise.all(usuarios.map(async usuario => {
            if (usuario.imagenUrl && usuario.imagenUrl !== defaultImage && usuario.imagenUrl !== "") {
                try {
                    const imageObjectURL = await srvObtenerFotoPerfil(userData, usuario.imagenUrl)
                    return { ...usuario, imagenBlob: imageObjectURL };
                } catch (error) {
                    console.error(`Error al cargar la imagen para el usuario ${usuario.id}:`, error);
                    return { ...usuario, imagenBlob: usuario };
                }
            } else {
                return { ...usuario, imagenBlob: imagenSpotNoFoto };
            }
        }));

        setSpotsSinFiltrar(usuariosConImagenes);
    };

    const handleInputChange = (e) => {

        const { name, value } = e.target;
        console.log("Texto buscado", value)
        setTextoBuscado(value)

    };
    const crearSpot = () => {
        navigate("edicion", { state: { usuario: null } })
    }


    const buscarCantidadTotemsSinActivar = () => {
        // console.log("asds")
        const fetchData = async () => {
            try {
                const spotsFromServer = await srvBuscarCantidadTotemsSinActivar(userData);
                console.log(spotsFromServer)
                // console.log("authorization", userInfo.headers.getAuthorization)
                if (spotsFromServer) {
                    console.log(spotsFromServer.data.datos.cantidadTotemsSinActivar)

                    setCantidadTotemsSinActivar(spotsFromServer.data.datos.cantidadTotemsSinActivar)
                    // Cargar las imágenes después de actualizar el estado de los usuarios

                    // props.handleLogged(userInfo.data)
                }
                // navigate("/panel");
                else
                    setError("Error al buscar los usuarios")
            } catch (error) {
                console.log("error.message", "+" + error + "+")
                if (error == 'Error: Error del servidor: 401') {
                    console.log("ahora si 401")
                    dispatch(cerrarSesion());
                } else {
                    setError('Error al procesar la solicitud');
                }


            }
        };
        fetchData();
    }


    const simular = (idEncuestaHash) => {
        console.log("idEncuestaHash", idEncuestaHash)


        setSpotSelected({ idEncuestaHash: idEncuestaHash })
        setIsModalSimuladorOpen(true)

    }

    const desactivarEncuesta = (idSpotHash) => {
        console.log(idSpotHash)

        const fetchData = async () => {
            try {
                const spotsFromServer = await srvDesactivarEncuesta(userData, idSpotHash);

                if (spotsFromServer) {
                    getSpotsFromServer()
                }
                else
                    setError("Error al buscar los usuarios")
            } catch (error) {
                console.log("error.message", "+" + error + "+")
                if (error == 'Error: Error del servidor: 401') {
                    console.log("ahora si 401")
                    dispatch(cerrarSesion());
                } else {
                    setError('Error al procesar la solicitud');
                }
            }
        };
        fetchData();


    }



    const accionConfirmada = () => {
        setIsOpenModal(false)
        console.log(accionAConfirmar)
        switch (accionAConfirmar.accion) {
            case ACCION_DESACTIVAR.accion:
                desactivarEncuesta(spotSelected.idSpotHash)
                break
            default:
                break
        }
    }


    const pedirConfirmacion = (spot, accion) => {
        setSpotSelected(spot)
        setAccionAConfirmar(accion)
        setIsOpenModal(true)
    }
    const totalSpots = spotsSinFiltrar.length;
    const filteredSpots = spotsFiltrados.length;
    const filteredLabel = textoBuscado.trim().length > 0 ? 'Coincidencias' : 'Spots visibles';

    return (
        <div className={stylesPanel.containerPrincipal}>
            <HeaderTituloComponent pagina={HeaderTituloComponent.PAGINA_SPOTS_PRINCIPAL}></HeaderTituloComponent>

            <div className={stylesPanel.containerPanel}>
                <div className={styles.pageHeader}>
                    <div>
                        <h2 className={styles.pageTitle}>Gestiona tus spots</h2>
                        <p className={styles.pageSubtitle}>
                            Mantén tus totems activos y asignados a las encuestas correctas para no perder mediciones.
                        </p>
                    </div>
                    <div className={styles.metrics}>
                        <div className={styles.metric}>
                            <span className={styles.metricValue}>{totalSpots}</span>
                            <span className={styles.metricLabel}>Spots totales</span>
                        </div>
                        <div className={styles.metric}>
                            <span className={styles.metricValue}>{filteredSpots}</span>
                            <span className={styles.metricLabel}>{filteredLabel}</span>
                        </div>
                    </div>
                </div>

                <div className={styles.actionsBar}>
                    <div className={styles.searchWrapper}>
                        <InputText
                            id="buscar"
                            name="buscar"
                            value={textoBuscado}
                            type={'search'}
                            onChangeInput={handleInputChange}
                            placeholder={'Busca spots...'}
                            mensajeError={errorBuscar}
                        ></InputText>
                    </div>
                    <div className={styles.createWrapper}>
                        <BotonPrincipal text="Crear spot" icono={BotonPrincipal.ICONO_CREAR} onClick={() => crearSpot()} width={'220px'} />
                    </div>
                </div>

                {cantidadTotemsSinActivar > 0 && (
                    <div className={styles.infoBanner}>
                        <CuadroAyuda
                            titulo={`Tienes ${cantidadTotemsSinActivar} Totems sin asignar`}
                            texto="Puedes asignar estos totems disponibles a cualquier spot y luego activar un nuevo dispositivo."
                        ></CuadroAyuda>
                    </div>
                )}

                {spotsFiltrados.length > 0 ? (
                    <div className={styles.spotsGrid}>
                        {spotsFiltrados.map((spot, index) => {
                            const totalTotems = Number(spot.cantidadTotems || 0);
                            const activeTotems = Number(spot.cantidadTotemsAsignados || 0);
                            const progress = totalTotems > 0 ? Math.min(100, Math.round((activeTotems / totalTotems) * 100)) : 0;

                            return (
                                <article key={index} className={styles.spotCard}>
                                    <div className={styles.cardMedia}>
                                        <img
                                            src={spot.imagenBlob ? spot.imagenBlob : imagenSpotNoFoto}
                                            alt={`Imagen del spot ${spot.spot}`}
                                            className={styles.spotImage}
                                        />
                                        <span className={styles.spotBadge}>Totems {activeTotems}/{totalTotems}</span>
                                    </div>
                                    <div className={styles.cardBody}>
                                        <div className={styles.cardHeader}>
                                            <h3 className={styles.cardTitle}>{spot.spot}</h3>
                                            {spot.descripcion && <p className={styles.cardSubtitle}>{spot.descripcion}</p>}
                                        </div>
                                        <div className={styles.metaList}>
                                            <div className={styles.metaItem}>
                                                <span className={styles.metaLabel}>Creado por</span>
                                                <span className={styles.metaValue}>{spot.creadoPor || '-'}</span>
                                            </div>
                                            {spot.fechaCreacion && (
                                                <div className={styles.metaItem}>
                                                    <span className={styles.metaLabel}>Fecha de creación</span>
                                                    <span className={styles.metaValue}>{spot.fechaCreacion}</span>
                                                </div>
                                            )}
                                        </div>

                                        {spot.idEncuestaHash ? (
                                            <div className={styles.surveySection}>
                                                <span className={styles.surveyTitle}>Encuesta activa</span>
                                                <span className={styles.surveyValue}>{spot.encuestaActiva}</span>
                                                {spot.fechaActivacionEncuesta && (
                                                    <span className={styles.surveyMeta}>Activada el {spot.fechaActivacionEncuesta}</span>
                                                )}
                                                <div className={styles.ctaGroup}>
                                                    <BotonPrincipal
                                                        text="Simular"
                                                        onClick={() => simular(spot.idEncuestaHash)}
                                                        width={'100%'}
                                                        icono={BotonPrincipal.ICONO_SIMULAR}
                                                    />
                                                    <BotonPrincipal
                                                        text="Desactivar encuesta"
                                                        onClick={() => pedirConfirmacion(spot, ACCION_DESACTIVAR)}
                                                        width={'100%'}
                                                        icono={BotonPrincipal.ICONO_ELIMINAR}
                                                    />
                                                </div>
                                            </div>
                                        ) : (
                                            <div className={`${styles.surveySection} ${styles.surveySectionEmpty}`}>
                                                <span className={`${styles.surveyTitle} ${styles.surveyTitleEmpty}`}>Sin encuesta activa</span>
                                                <span className={styles.surveyMeta}>Asigna una encuesta para comenzar a medir este spot.</span>
                                                <div className={styles.ctaGroup}>
                                                    <BotonPrincipal
                                                        text="Asignar encuesta"
                                                        onClick={() => navigate('seleccion-encuesta', { state: { spot: spot } })}
                                                        width={'100%'}
                                                        icono={BotonPrincipal.ICONO_ENCUESTA}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        <div className={styles.progressSection}>
                                            <span className={styles.progressLabel}>
                                                {totalTotems > 0
                                                    ? `Totems activos ${activeTotems} de ${totalTotems}`
                                                    : 'Sin totems asignados'}
                                            </span>
                                            {totalTotems > 0 && <ProgressBar progress={progress} />}
                                        </div>

                                        <div className={styles.divider}></div>

                                        <div className={styles.ctaGroup}>
                                            <BotonPrincipal
                                                text="Editar spot"
                                                onClick={() => navigate('edicion', { state: { spot: spot } })}
                                                width={'100%'}
                                                icono={BotonPrincipal.ICONO_MODIFICAR}
                                            />
                                            <BotonPrincipal
                                                text="Gestión de totems"
                                                onClick={() => navigate('agregar-totems', { state: { spot: spot } })}
                                                width={'100%'}
                                                icono={BotonPrincipal.ICONO_MODIFICAR}
                                            />
                                            <BotonPrincipal text="Eliminar" width={'100%'} icono={BotonPrincipal.ICONO_ELIMINAR} />
                                        </div>
                                    </div>
                                </article>
                            );
                        })}
                    </div>
                ) : (
                    <div className={styles.emptyState}>
                        {textoBuscado.trim().length > 0
                            ? 'No encontramos spots que coincidan con tu búsqueda.'
                            : 'Aún no has creado spots. Presiona “Crear spot” para comenzar.'}
                    </div>
                )}
            </div>


            <SimuladorPage
                isOpen={isModalSimuladorOpen}
                onClose={() => setIsModalSimuladorOpen(false)}
                encuesta={spotSelected}

            />


            <ConfirmationModalComponent
                isOpen={isOpenModal}
                onClose={() => setIsOpenModal(false)}
                onConfirm={accionConfirmada}
                title={accionAConfirmar.titulo}>
                {accionAConfirmar.mensaje}
            </ConfirmationModalComponent>


        </div >
    )
}

export default SpotsPage;
